export const flags = Object.freeze({
  USE_GATEWAY: "ui.api.gateway"
});
